const angular = require('angular')
const debounce = require('lodash/debounce')

module.exports = ['$scope', '$rootScope', '$state', '$element', '$timeout', '$ionicScrollDelegate', '$translate', '$utils',
  function ($scope, $rootScope, $state, $element, $timeout, $ionicScrollDelegate, $translate, $utils) {
    const $readScope = $scope.$parent.$parent.$parent
    // 上下封邮件的时候，只是改变读信view的数据， readContentCtl不是再次执行，需要readCtrl发送事件通知
    $scope.$on('READ.MAINCONTENT', function () {
      if ($element[0]) {
        $element[0].setAttribute('style', '')
        $element.parent()[0] && $element.parent()[0].setAttribute('style', '')
      }
      handleMailContent()
    })
    /* 当html格式的信件内容比页面大的时候,需要计算以及缩放来显示正文 */
    function handleMailContent() {
      $ionicScrollDelegate.resize()
      $ionicScrollDelegate.$getByHandle('readscroll').getScrollView().options.preventDefault = false
      $element.ready(function () {
        const scaleContent = $element[0]
        const parentContent = $element.parent()[0]
        parentContent.classList.add('read-content-anime')
        $element.find('base').remove() // 暂时把读信内容设置的默认链接删除
        if (!parentContent) {
          return false
        }
        if (!$rootScope.settings.featureControl.read.enableAttachmentDownload) {
          scaleContent.querySelectorAll('.down_big').forEach(item => {
            item.remove()
          })
        }
        // handleBigTables(angular.element(scaleContent.getElementsByTagName('table')))
        handleHyperLinks(angular.element(scaleContent.getElementsByTagName('a')))
        $readScope.$broadcast('READ.CONTENT_LOADED')
      })
    }
    // eslint-disable-next-line
    function handleBigTables(bigTables) {
      // CIM-27002 保持和webmail展示一样
      const calcTableWidth = function(table) {
        if (table.style.width) return table.style.width

        const tableClone = table.cloneNode(true)
        const div = document.createElement('div')
        div.style.width = '1920px'
        div.style.position = 'fixed'
        div.style.left = '-9999px'
        div.appendChild(tableClone)
        document.body.appendChild(div)
        const width = tableClone.offsetWidth + 'px'
        document.body.removeChild(div)
        return width
      }
      for (let i = 0; i < bigTables.length; i++) {
        const table = bigTables[i]
        const div = document.createElement('div')
        div.style.overflow = 'auto'
        table.style.width = calcTableWidth(table)
        div.appendChild(table.cloneNode(true))
        table.parentNode.replaceChild(div, table)
      }
    }

    function handleHyperLinks(hyperLinks) {
      //  preventDefault  需谨慎处理，只需在特殊情况下加上！如：mailto
      hyperLinks.on('click', debounce(evt => {
        const that = evt.target
        const link = that.href

        if (~link.indexOf('mailto:')) { // 邮件地址
          $utils.$uiHelper.stop(evt)
          const email = link.split('mailto:')[1]
          !$rootScope.isReadOnly && $state.go('frame.compose', { action: 'compose', email: email })
        } else if (~link.indexOf('viewDownloadFile.jsp')) { // 超大附件下载
          if (
            !$rootScope.settings.featureControl.read.enableAttachmentDownload ||
            $utils.$misc.MD.isAppEmbed
          ) {
            $utils.$uiHelper.stop(evt)
            $utils.$notify.set({ message: $translate.instant('READ.BIG_ATTACHMENT_DOWNLOAD_TIPS') })
          }
        } else if ($rootScope.settings.enableHyperLinkSecurityAlert) { // 配置安全链接提示
          const urlParseResult = $utils.$html.parseURL(link)
          if (!~$rootScope.settings.secureHyperLinkList.indexOf(urlParseResult.hostname)) {
            $utils.$uiHelper.stop(evt)
            $utils.$pop.confirmPopup('', $translate.instant('READ.TIP_UNTRUSTED_LINK', {url: link}), {
              highlightCancel: true
            }).then(res => {
              if (!res) return

              that.cloneNode().click()
            })
          }
        } else if ($scope.readingMsgInfo.isStranger) { // 陌生人邮件
          $utils.$uiHelper.stop(evt)
          $utils.$pop.confirmPopup('', $translate.instant('READ.TIP_STRANGER_LINK'), {
            highlightCancel: true
          }).then(res => {
            if (!res) return

            that.cloneNode().click()
          })
        }
      }, 300, {leading: true}))
    }
  }]



// WEBPACK FOOTER //
// ./src/js/mail/read/readContentCtrl.js